import React, { useEffect, useRef, useCallback, useMemo } from 'react';
import {
  injectMemberCardEffectStyles,
  bindMemberCardShellTilt,
} from './memberCardEffectStyles';
import { flattenStyleForWeb, getMemberCardShellWebStyle } from './calendarGlassStyles';
import { useMasterTourCalendarUi } from '../../contexts/FeatureFlagsContext';

const SHELL_CLASS = 'vrc-member-card-shell';

/**
 * Web card shell — glass gradient, glimmer sweep, mouse-tilt 3D hover.
 */
export function TourPartyMemberCardShell({
  children,
  style,
  onPress,
  onMouseEnter,
  onMouseLeave,
  className = '',
  isDarkMode = true,
}) {
  const v2Layout = useMasterTourCalendarUi();
  const shellRef = useRef(null);

  const shellStyle = useMemo(
    () => ({
      ...getMemberCardShellWebStyle(isDarkMode, v2Layout),
      ...flattenStyleForWeb(style),
      ...(flattenStyleForWeb(style)?.width != null
        ? {
            width: flattenStyleForWeb(style).width,
            maxWidth: flattenStyleForWeb(style).width,
            minWidth: flattenStyleForWeb(style).width,
          }
        : {}),
    }),
    [isDarkMode, style, v2Layout]
  );

  useEffect(() => {
    injectMemberCardEffectStyles(isDarkMode);
  }, [isDarkMode]);

  useEffect(() => {
    const el = shellRef.current;
    if (!el) return undefined;
    return bindMemberCardShellTilt(el, onMouseLeave);
  }, [onMouseLeave]);

  const handleClick = useCallback(
    (event) => {
      if (!onPress) return;
      event.preventDefault?.();
      onPress(event);
    },
    [onPress]
  );

  return (
    <div
      ref={shellRef}
      className={`${SHELL_CLASS} ${className}`.trim()}
      data-clickable={onPress ? 'true' : 'false'}
      style={shellStyle}
      onMouseEnter={onMouseEnter}
      onClick={handleClick}
      role={onPress ? 'button' : undefined}
      tabIndex={onPress ? 0 : undefined}
    >
      <div className="vrc-member-card-glimmer" aria-hidden="true" />
      {children}
    </div>
  );
}

export default TourPartyMemberCardShell;
